type Listener = (visible: boolean) => void;

const listeners: Listener[] = [];

var visible = true;

function focused() {
  if (!visible) {
    listeners.forEach(fn => fn((visible = true)));
  }
}

function unfocused() {
  if (visible) {
    listeners.forEach(fn => fn((visible = false)));
  }
}

if ('hidden' in document) {
  document.addEventListener('visibilitychange', function() {
    (document.hidden ? unfocused : focused)();
  });
}

// All others:
window.onpageshow = window.onfocus = focused;
window.onpagehide = window.onblur = unfocused;

export function listen(fn: Listener) {
  listeners.push(fn);
}

export function unlisten(fn: Listener) {
  const index = listeners.indexOf(fn);

  if (index >= 0) {
    listeners.splice(index, 1);
  }
}

export default {
  listen,
  unlisten,
  get isVisible() {
    return visible;
  },
};
